var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappSquareSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#4CAF50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0015 4H9.9985C6.69025 4 4 6.691 4 10C4 11.3125 4.423 12.529 5.14225 13.5168L4.3945 15.7458L6.70075 15.0085C7.6495 15.637 8.78125 16 10.0015 16C13.3097 16 16 13.3083 16 10C16 6.69175 13.3097 4 10.0015 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4927 12.4728C13.348 12.8815 12.7735 13.2205 12.3152 13.3195C12.0017 13.3863 11.5922 13.4395 10.2137 12.868C8.45048 12.1375 7.31498 10.3458 7.22648 10.2295C7.14173 10.1133 6.51398 9.28076 6.51398 8.41976C6.51398 7.55876 6.95123 7.13951 7.12748 6.95951C7.27223 6.81176 7.51148 6.74426 7.74098 6.74426C7.81523 6.74426 7.88198 6.74801 7.94198 6.75101C8.11823 6.75851 8.20673 6.76901 8.32298 7.04726C8.46773 7.39601 8.82023 8.25701 8.86223 8.34551C8.90498 8.43401 8.94773 8.55401 8.88773 8.67026C8.83148 8.79026 8.78198 8.84351 8.69348 8.94551C8.60498 9.04751 8.52098 9.12551 8.43248 9.23501C8.35148 9.33026 8.25998 9.43226 8.36198 9.60851C8.46398 9.78101 8.81648 10.3563 9.33548 10.8183C10.0052 11.4145 10.5482 11.605 10.7425 11.686C10.8872 11.746 11.0597 11.7318 11.1655 11.6193C11.2997 11.4745 11.4655 11.2345 11.6342 10.9983C11.7542 10.8288 11.9057 10.8078 12.0647 10.8678C12.2267 10.924 13.084 11.3478 13.2602 11.4355C13.4365 11.524 13.5527 11.566 13.5955 11.6403C13.6375 11.7145 13.6375 12.0633 13.4927 12.4728Z",
    fill: "#4CAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.5L4.3999 15.8L8 15L5.5 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappSquareSm);
export default __webpack_public_path__ + "static/media/whatsapp_square_sm.79e47eefc3e95d47b219eb1319c64c32.svg";
export { ForwardRef as ReactComponent };